import { lazy } from 'react'

import { PATH_NEW_LOADER } from 'config/paths'

export const EreaderRoutes = [
    {
        id: 1,
        module: 'loader-ereader',
        protected: false,
        exact: true,
        path: PATH_NEW_LOADER.pages.eReader,
        component: lazy(
            () =>
                import(
                    // eslint-disable-next-line max-len
                    'containers/emulator/pages/e-reader/EReaderPage'
                ),
        ),
    },
]
